import * as React from 'react';

import { Wrapper, Position, Label } from './styles';

interface ItemInfoProps {
	spreadIndex: number;
	label: string;
}

const ItemInfo = ({ spreadIndex, label }: ItemInfoProps) => (
	<Wrapper>
		<Position>{spreadIndex + 1}</Position>
		<Label>{label}</Label>
	</Wrapper>
);

export default ItemInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/ItemInfo/index.tsx